/* XECAR · Botón de WhatsApp nativo */
if (!customElements.get('xe-wa')) {
  customElements.define(
    'xe-wa',
    class XeWa extends HTMLElement {
      connectedCallback() {
        this.btn = this.querySelector('.xe-wa__btn');
        this.card = this.querySelector('.xe-wa__card');
        this.onDoc = (e) => { if (!this.contains(e.target)) this.close(); };
        this.onKey = (e) => { if (e.key === 'Escape') this.close(true); };
        this.btn.addEventListener('click', () => (this.card.hidden ? this.open() : this.close()));
        this.querySelector('.xe-wa__x').addEventListener('click', () => this.close(true));
        this.querySelector('.xe-wa__agent').addEventListener('click', () => {
          const data = { source: 'boton-flotante', page: location.pathname };
          try { window.Shopify?.analytics?.publish?.('xecar_whatsapp_click', data); } catch (e) {}
          try { (window.dataLayer = window.dataLayer || []).push({ event: 'whatsapp_click', ...data }); } catch (e) {}
          try { window.fbq?.('track', 'Contact'); } catch (e) {}
          this.close();
        });
      }
      open() {
        this.card.hidden = false;
        this.btn.setAttribute('aria-expanded', 'true');
        setTimeout(() => document.addEventListener('click', this.onDoc), 0);
        document.addEventListener('keydown', this.onKey);
      }
      close(focus) {
        this.card.hidden = true;
        this.btn.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onDoc);
        document.removeEventListener('keydown', this.onKey);
        if (focus) this.btn.focus();
      }
    }
  );
}

/* XECAR · Carrito → WhatsApp: arma la lista desde /cart.js en el momento del envío */
(() => {
  const KEY = 'xe-cartwa-datos';
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } };
  const save = (d) => { try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {} };
  const fill = () => {
    const d = load();
    document.querySelectorAll('[data-xe-cartwa] input[name]').forEach((i) => { if (d[i.name] && !i.value) i.value = d[i.name]; });
  };
  const money = (cents) => new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(cents / 100);

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-xe-cartwa-send]');
    if (!btn) return;
    e.preventDefault();
    const box = btn.closest('[data-xe-cartwa]');
    const win = window.open('', '_blank');
    btn.setAttribute('aria-busy', 'true');
    let cart = { items: [] };
    try { cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()); } catch (err) {}
    btn.removeAttribute('aria-busy');
    if (!cart.items.length) { if (win) win.close(); return; }

    const threshold = Number(box.dataset.threshold || 0);
    const withLinks = box.dataset.links === 'true' && cart.items.length <= 15;
    const lines = cart.items.map((i) => {
      const variant = i.variant_title && !/default title/i.test(i.variant_title) ? ` – ${i.variant_title}` : '';
      const ref = i.sku ? ` (Ref. ${i.sku})` : '';
      const price = i.final_price > threshold ? ` – ${money(i.final_price)} c/u` : '';
      const link = withLinks ? `\n   ${box.dataset.origin}${i.url.split('?')[0]}` : '';
      return `• ${i.quantity} × ${i.product_title}${variant}${ref}${price}${link}`;
    });

    const datos = {};
    box.querySelectorAll('input[name]').forEach((inp) => { if (inp.value.trim()) datos[inp.name] = inp.value.trim(); });
    const stored = { ...load(), ...datos };
    if (Object.keys(datos).length) save(stored);
    const extra = [];
    if (stored.xe_name) extra.push(`Nombre: ${stored.xe_name}`);
    if (stored.xe_company) extra.push(`Empresa: ${stored.xe_company}`);
    if (stored.xe_city) extra.push(`Ciudad: ${stored.xe_city}`);

    const msg = `${box.dataset.intro || 'Hola XECAR, quiero cotizar:'}\n\n${lines.join('\n')}${extra.length ? `\n\n${extra.join('\n')}` : ''}`;
    const href = `https://wa.me/${box.dataset.number}?text=${encodeURIComponent(msg)}`;

    const data = { items: cart.item_count, lines: cart.items.length, page: location.pathname };
    try { window.Shopify?.analytics?.publish?.('xecar_cotizacion_whatsapp', data); } catch (err) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'cotizacion_whatsapp', ...data }); } catch (err) {}
    try { window.fbq?.('track', 'Lead', { content_name: 'Cotización WhatsApp', num_items: cart.item_count }); } catch (err) {}

    if (win) win.location.href = href; else window.location.href = href;
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fill); else fill();
  document.addEventListener('shopify:section:load', fill);
})();
